import { create } from 'zustand';
import jwtdecode from 'jwt-decode';
import { isJwtExpired } from '../utils';
export const useAuthStateStore = create((set, get) => ({
    token: undefined,
    hasAuthInitialized: false,
    setHasAuthInitialized: (has) => set(() => ({
        hasAuthInitialized: has,
    })),
    isAuthValid: () => {
        const { hasAuthInitialized, accessTokenExpirationDate } = get();
        if (!hasAuthInitialized || !accessTokenExpirationDate)
            return false;
        const expiration = new Date(accessTokenExpirationDate);
        const secondsTilExpiration = (expiration.valueOf() - Date.now()) / 1000;
        return secondsTilExpiration > 0;
    },
    accessTokenExpirationDate: undefined,
    setToken: (token, setIfExpired = false) => set((state) => {
        let jwt;
        let uuid = undefined;
        try {
            jwt = jwtdecode(token);
        }
        catch (err) {
            console.error(`Invalid JWT`, err);
        }
        if (jwt) {
            uuid = jwt.sub;
        }
        const isExpired = isJwtExpired(token);
        const expirationDate = new Date(jwt.exp * 1000).toISOString();
        if (isExpired && !setIfExpired) {
            return {
                token: undefined,
                jwt: undefined,
                uuid: undefined,
                accessTokenExpirationDate: undefined,
                hasAuthInitialized: true,
            };
        }
        return {
            token: token,
            jwt: jwt,
            uuid: uuid,
            accessTokenExpirationDate: expirationDate,
            hasAuthInitialized: true,
        };
    }),
    removeToken: () => set(() => ({
        token: undefined,
        jwt: undefined,
        uuid: undefined,
        accessTokenExpirationDate: undefined,
        hasAuthInitialized: true,
    })),
    getUUID: (publicIfNull = false) => {
        const uuid = get().uuid;
        if (uuid === undefined) {
            if (publicIfNull === false) {
                return undefined;
            }
            else {
                return 'public';
            }
        }
        else {
            return uuid;
        }
    },
}));
//# sourceMappingURL=useAuthStateStore.js.map